import type { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthGuard } from '../AuthGuard';

/**
 * ClientLayout - Layout wrapper for client/customer routes
 *
 * Only uses AuthGuard to ensure user is authenticated.
 *
 * NOTE: RoleGuard was removed because:
 * 1. PostLogin uses the bootstrap API to determine user type
 * 2. Users routed to /client/* have already been validated as clients
 * 3. The useAuth() role only tracks provider roles, not client role
 * 4. Clients don't have provider records, so role was null, causing unauthorized redirects
 *
 * The bootstrap API + PostLogin routing is the source of truth for user type.
 *
 * Usage in RouterConfig:
 * <Route element={<ClientLayout />}>
 *   <Route path="dashboard" element={<ClientDashboard />} />
 *   <Route path="bookings" element={<BookingHistory />} />
 * </Route>
 */
export const ClientLayout: FC = () => {
  return (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  );
};
